import React, { useEffect } from "react";

import BannerSection from "../../shared/components/BannerSection/BannerSection";
import MembershipTerms from '../components/MembershipTerms/MembershipTerms';

import termsOfServiceBannerImg from '../../utils/assets/termsOfService/lawyer-ferret.png';
import NavegationInfo from "../../shared/components/NavegationInfo/NavegationInfo";

const TermsOfService = props => {

    const bannerSectionInfo =
     {
        cardTitle: "Terms and conditions for using this service",
        cardButtonText: "Make a Call",
        lengendBackground: termsOfServiceBannerImg
     }
    
     useEffect(()=>{
        window.scroll(0,0);

        return ()=>{
            sessionStorage.clear();
        }
     })

    return (
        <React.Fragment>
           <BannerSection props={bannerSectionInfo}/>  
           <NavegationInfo page="Terms of service"/>
           <MembershipTerms/> 
        </React.Fragment>
    );
};

export default TermsOfService;